import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Card, CardContent, CardReview } from "../../uiComps/Card";
import { Star, Quote } from "lucide-react";
import { Button, Input, Textarea, Select, SelectItem } from "../../uiComps/Utils";
const serviceLabels = {
  payroll: 'Payroll Services',
  sole_traders: 'Sole Traders & Partnerships',
  vat_returns: 'VAT Returns',
  limited_companies: 'Limited Companies',
  bookkeeping: 'Bookkeeping',
  general: 'General'
};

export default function Reviews() {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    rating: 5,
    review: '',
    service: 'general'
  });
  const reviews = [
  {
    id: 1,
    name: "Anthony Bear",
    rating: 5,
    review: "I have been using BakerKerry Accountants since 2010. Theres never any fuss and communication is clear and concise. They are always able to answer any questions with ease and are a pleasure to deal with."
  },
  {
    id: 2,
    name: "Universal Print Finishers Limited",
    rating: 5,
    review: "What really sets BakerKerry apart is their responsiveness and attention to detail. We wouldn’t hesitate to recommend Baker Kerry Accountants to any business looking for dependable, expert accounting support."
  },
   {
    id: 3,
    name: "Trevor Peat",
    rating: 5,
    review: "I have used BakerKerry accountants for some years now , they are friendly and easy to work with . They have offices at their home’s  so it makes it much more comfortable than visiting a big accounting office . They have all the knowledge and experience though and it’s good to know that everything is being done right. They are a reasonable price as well,  I would highly recommend them"
  },
  { id: 4,
    name: "Wayne Hallam",
    rating: 5,
    review: "After being with BakerKerry Accountants for some years now I can honestly say they are the best I've had to sort and help deal with my business accounts, they are very knowledgable and always on point to helping me whenever I need them and give a quick response every time to solve any issues I have or help in understanding anything that I need with my accounts. They are very friendly and always happy to help."
  },
  
  { id: 5,
    name: "Bentley Financial Services Ltd",
    rating: 5,
    review: "I’ve been really impressed with the service from Mel! She is very speedy at replying to messages and always on hand to answer any questions I have, which makes things much less stressful. They are also a more price competitive than my previous accountant while still providing a great level of support. Mel is a lovely, reliable and helpful accountant that I’d happily recommend to anyone!"
  },
  { id: 6,
      name: "Tracy",
      rating: 5,
      review: "BakerKerry Accountants are a wonderful pair of ladies who we've had the pleasure of using for our small family business for the last 18yrs, they are very professional and helpful in all matters relating to the financial side and are there to assist with any queries or help I need to understand things. We would highly recommend them to anybody who us looking for accountants to help with their business needs."
    }
  
];

  

  return (
    <section id="reviews" className="py-24 bg-slate-900">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-amber-500 font-medium text-sm tracking-wider uppercase">Testimonials</span>
          <h2 className="text-4xl md:text-5xl font-light text-white mt-4 mb-6">What Our Clients Say</h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto font-light">
            Don't just take our word for it — hear from businesses we've helped
          </p>
        </motion.div>

          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-12">
            {reviews.map((review, index) => (
              <motion.div 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="mb-16 text-left" // changed from text-center
                >
                <CardReview className="h-full bg-slate-800/50 border-slate-700 backdrop-blur-sm">
                  <CardContent className="p-6">
                  <Quote className="w-8 h-8 text-amber-500/30 mb-4" />
                   <div className="flex gap-1 mb-4">
                      {[...Array(5)].map((_, i) => (
                        <Star 
                          key={i} 
                          className={`w-4 h-4 ${i < review.rating ? 'text-amber-500 fill-amber-500' : 'text-slate-600'}`} 
                        />
                      ))}
                    </div>

                    <p className="text-slate-300 font-light leading-relaxed mb-6">
                      "{review.review}"
                    </p>

                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-slate-300 font-medium">{review.name}</p>
                        <p className="text-slate-300 text-sm">{serviceLabels[review.name] || 'Client'}</p>
                      </div>
                    </div>
                  </CardContent>
                </CardReview>
              </motion.div>
            ))}
          </div>
        </div>
      
    </section>
  );
}